import React, { useState } from 'react';
import { FormContainer } from 'modules/2023-q3/components/forms/components/form-container/form-container';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from 'modules/2023-q3/components/accordion/accordion';
import { ReactComponent as ArrowDropDownIcon } from 'assets/icons/arrows/caret-down.svg';
import { Box, Grid } from '@material-ui/core';
import { Typography, TypographyVariant } from 'components/core';
import { useBankAccounts } from 'hooks/banking/use-bank-accounts';
import { useBusiness } from 'hooks/business/use-business';
import { BankAccount } from 'types';
import { Button } from 'modules/2023-q3/components/button/button';

interface Props {
  onClick: () => void;
}

export const ApexAchDepositLimitMessage: React.FC<Props> = ({ onClick }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <FormContainer>
      <Accordion expanded={isExpanded} onClick={onClick}>
        <AccordionSummary>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item>
                  <Box mb={1}>
                    <Typography
                      color="grey1"
                      variant={TypographyVariant.Paragraph1}
                    >
                      ACH Deposit Limit
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <Box mb={1}>
                <Typography
                  color="grey1"
                  variant={TypographyVariant.Paragraph2}
                >
                  ACH Deposits are limited to $100,000 a day.
                </Typography>
              </Box>
            </Grid>

            <Grid item>
              <Typography color="grey1" variant={TypographyVariant.Paragraph2}>
                To deposit more than $100,000, please{' '}
                <Button bgColor="white" bgHoverColor="white" variant="text">
                  use a wire
                </Button>
                .
              </Typography>
            </Grid>
          </Grid>
        </AccordionSummary>
      </Accordion>
    </FormContainer>
  );
};
